import { z } from "zod/v4";
import { paginationSearchSchema } from "#/modules/util.pagination/search.pagination";

/**
 * Search params schema for classes overview: `searchTerm`, `orderBy`, `orderDirection`, and pagination.
 */
export const classesSearchSchema = paginationSearchSchema.extend({
  searchTerm: z.string().default(""),
  orderBy: z.string().default("name"),
  orderDirection: z.enum(["ascending", "descending"]).default("ascending").catch("ascending"),
});

/** Default values for classes search params; values not explicitly set will be omitted from URL. */
export const CLASSES_SEARCH_DEFAULTS = {
  searchTerm: "",
  orderBy: "name",
  orderDirection: "ascending" as const,
  page: 1,
  pageSize: 40,
};

export type ClassesSearch = z.infer<typeof classesSearchSchema>;
